export const translations = {
  fr: {
    // Landing
    landing: {
      title: 'A-More AI',
      subtitle: "L'intelligence artificielle au service de l'amour",
      description: "Trouvez votre âme sœur grâce à notre IA avancée qui analyse vos affinités profondes",
      btnSignup: 'Commencer gratuitement',
      btnLogin: 'Se connecter',
      freeSignup: 'Les 500 premiers inscrits gratuits !',
      whyTitle: 'Pourquoi A-More AI ?',
      aiAdvanced: 'IA Avancée',
      aiAdvancedDesc: 'Analyse NLP pour comprendre votre personnalité en profondeur',
      smartMatching: 'Matching Intelligent',
      smartMatchingDesc: 'Trouvez des personnes vraiment compatibles avec vous',
      chatAssisted: 'Chat Assisté',
      chatAssistedDesc: "L'IA vous aide à démarrer des conversations captivantes",
      secure: 'Sécurisé',
      secureDesc: 'Vos données sont protégées et sécurisées',
      readyTitle: "Prêt à trouver l'amour ?",
      readyDesc: 'Rejoignez des milliers de célibataires qui ont déjà trouvé leur match parfait',
      btnCta: 'Créer mon compte'
    },
    // Auth
    auth: {
      welcomeBack: 'Bon retour !',
      joinUs: 'Rejoignez A-More AI',
      loginDesc: "Connectez-vous pour trouver l'amour",
      signupDesc: 'Créez votre compte gratuitement',
      fullName: 'Nom complet',
      age: 'Âge',
      gender: 'Genre',
      male: 'Homme',
      female: 'Femme',
      location: 'Localisation',
      email: 'Email',
      password: 'Mot de passe',
      btnLogin: 'Se connecter',
      btnSignup: 'Créer mon compte',
      toggleSignup: "Pas encore de compte ? Inscrivez-vous",
      toggleLogin: 'Déjà un compte ? Connectez-vous',
      donationNote: "En cas de rencontre réussie, nous vous encourageons à faire un don pour soutenir l'application.",
      ageError: 'Vous devez avoir au moins 18 ans pour vous inscrire',
      acceptTerms: "J'accepte les",
      termsLink: 'conditions générales',
      termsRequired: 'Vous devez accepter les conditions générales'
    },
    // Questionnaire
    questionnaire: {
      title: 'Parlez-nous de vous',
      subtitle: 'Cela nous aidera à trouver votre match parfait',
      step: 'Question',
      interestsTitle: 'Quels sont vos intérêts ?',
      interestsDesc: 'Sélectionnez au moins 3 intérêts',
      personalityTitle: 'Votre personnalité',
      bioTitle: 'Finalisez votre profil',
      bio: 'Bio',
      bioPlaceholder: 'Parlez-nous de vous...',
      typePreference: 'Type de personne recherchée',
      typePlaceholder: "Ex: Quelqu'un d'aventureux, attentionné...",
      btnNext: 'Suivant',
      btnBack: 'Retour',
      btnFinish: 'Terminer',
      introverted: 'Introverti',
      extroverted: 'Extraverti',
      routine: 'Routine',
      adventure: 'Aventure',
      rational: 'Rationnel',
      emotional: 'Émotionnel',
      improvise: 'Improviser',
      plan: 'Planifier',
      alone: 'Seul(e)',
      group: 'En groupe'
    },
    // Dashboard
    dashboard: {
      logout: 'Déconnexion',
      myProfile: 'Mon Profil',
      discover: 'Découvrir',
      matches: 'Mes Matchs',
      premium: 'Premium',
      interests: 'Intérêts',
      typeSearched: 'Type recherché',
      notSpecified: 'Non spécifié',
      myPhotos: 'Mes Photos',
      noPhotos: 'Aucune photo ajoutée',
      addPhotosDesc: 'Ajoutez des photos pour augmenter vos chances de match !',
      btnStartMatching: 'Commencer le matching',
      noBio: 'Aucune bio pour le moment',
      noInterests: 'Aucun intérêt ajouté',
      addPhoto: 'Ajouter'
    },
    // Discover
    discover: {
      title: 'Découvrir',
      score: 'Score',
      noMoreProfiles: 'Plus de profils pour le moment',
      noMoreDesc: 'Revenez plus tard pour découvrir de nouveaux profils !',
      btnBackDashboard: 'Retour au tableau de bord',
      loading: 'Recherche de profils compatibles...'
    },
    // Matches
    matches: {
      title: 'Mes Matchs',
      noMatches: 'Aucun match pour le moment',
      noMatchesDesc: 'Commencez à swiper pour trouver des matchs !',
      btnDiscover: 'Découvrir des profils',
      btnChat: 'Discuter'
    },
    // Chat
    chat: {
      startConversation: 'Démarrez la conversation !',
      startDesc: 'Voici quelques suggestions pour briser la glace :',
      messagePlaceholder: 'Écrivez votre message...'
    },
    // Payment
    payment: {
      title: 'Inscription Premium',
      subtitle: 'Les 500 premiers inscrits gratuits ont été atteints',
      planTitle: 'Inscription A-More AI',
      planDesc: 'Accès complet à la plateforme',
      oneTime: 'Paiement unique',
      feature1: 'Matching IA illimité',
      feature2: 'Chat avec suggestions IA',
      feature3: 'Profil optimisé',
      feature4: 'Support prioritaire',
      btnPay: 'Payer avec Stripe',
      btnBack: "Retour à l'accueil",
      checking: 'Vérification du paiement...',
      wait: 'Veuillez patienter',
      success: 'Paiement réussi !',
      successDesc: 'Vous pouvez maintenant créer votre compte',
      btnContinue: "Continuer l'inscription",
      failed: 'Échec du paiement',
      failedDesc: "Votre paiement n'a pas abouti",
      btnRetry: 'Réessayer'
    },
    // Common
    common: {
      years: 'ans',
      loading: 'Chargement...',
      saving: 'Enregistrement...',
      sending: 'Envoi...',
      back: 'Retour'
    },
    // Interests
    interests: {
      music: 'Musique',
      cinema: 'Cinéma',
      travel: 'Voyages',
      sport: 'Sport',
      reading: 'Lecture',
      cooking: 'Cuisine',
      art: 'Art',
      tech: 'Technologie',
      nature: 'Nature',
      photo: 'Photographie',
      dance: 'Danse',
      yoga: 'Yoga'
    },
    // Menu / Footer
    menu: {
      tagline: "L'application de rencontre qui utilise l'IA pour créer des connexions authentiques.",
      discover: 'Découvrir',
      howItWorks: 'Comment ça marche',
      about: 'À propos',
      testimonials: 'Témoignages',
      faq: 'FAQ',
      blog: 'Blog',
      legal: 'Légal',
      terms: 'Conditions d\'utilisation',
      privacy: 'Politique de confidentialité'
    },
    // Stats
    stats: {
      menRegistered: 'Hommes inscrits',
      womenRegistered: 'Femmes inscrites',
      successfulMatches: 'Matchs réussis',
      activeMembers: 'Membres actifs'
    },
    // FAQ
    faq: {
      title: 'Questions Fréquentes',
      back: 'Retour',
      questions: [
        {
          q: "Qu'est-ce que A-More AI ?",
          a: "A-More AI est une application de rencontre innovante qui utilise l'intelligence artificielle Claude pour analyser vos affinités profondes et vous mettre en relation avec des personnes vraiment compatibles. Notre technologie avancée va au-delà des simples critères physiques pour comprendre votre personnalité, vos valeurs et vos aspirations."
        },
        {
          q: "Comment fonctionne le matching par IA ?",
          a: "Notre système utilise Claude AI, une intelligence artificielle de pointe, pour analyser votre questionnaire de personnalité approfondi. L'IA évalue vos traits de caractère, vos intérêts, vos valeurs et vos objectifs relationnels. Elle compare ensuite ces données avec celles des autres utilisateurs pour identifier les meilleures compatibilités, en calculant un score d'affinité basé sur de multiples dimensions."
        },
        {
          q: "L'application est-elle gratuite ?",
          a: "Les 500 premiers inscrits bénéficient d'un accès totalement gratuit à toutes les fonctionnalités de A-More AI. Après ces 500 inscriptions, un paiement unique de 10$ USD est requis pour accéder à la plateforme. Aucun abonnement récurrent, juste un paiement unique pour un accès illimité."
        },
        {
          q: "Mes données sont-elles protégées ?",
          a: "Absolument. Nous prenons la protection de vos données très au sérieux. A-More AI est conforme au RGPD et utilise un chiffrement de niveau bancaire pour protéger vos informations personnelles. Vous avez un droit d'accès, de rectification et de suppression de vos données à tout moment. Vous pouvez supprimer votre compte et toutes vos données via les paramètres."
        },
        {
          q: "Comment le questionnaire de personnalité améliore-t-il mes matchs ?",
          a: "Notre questionnaire approfondi explore 8 dimensions de compatibilité : vos valeurs, votre style de communication, vos objectifs de vie, vos loisirs, votre vision de la relation, votre gestion des conflits, votre expression émotionnelle et vos attentes. Plus vos réponses sont sincères et détaillées, plus l'IA peut identifier des profils vraiment compatibles avec vous."
        },
        {
          q: "Qu'est-ce que le système de notation sociale ?",
          a: "Le système de notation sociale permet aux utilisateurs de s'évaluer mutuellement après avoir matché sur 5 critères : Confiance, Sérieux, Générosité, Comportement et Communication. Ces notes sont anonymes et aident la communauté à identifier les profils de qualité. Vous pouvez noter une personne une seule fois par match, et vos propres scores détaillés sont visibles dans votre Dashboard."
        },
        {
          q: "Comment fonctionne le chat assisté par IA ?",
          a: "Une fois que vous avez un match mutuel, notre IA vous suggère des débuts de conversation personnalisés basés sur vos profils communs et les raisons de votre compatibilité. Ces suggestions sont conçues pour briser la glace naturellement et lancer des conversations authentiques et engageantes."
        },
        {
          q: "Puis-je utiliser A-More AI dans ma langue ?",
          a: "Oui ! A-More AI est disponible en 4 langues : Français, Anglais, Espagnol et Allemand. Vous pouvez changer de langue à tout moment via le sélecteur de langue en haut à droite de l'application."
        },
        {
          q: "Comment sont vérifiées les localisations ?",
          a: "Pour assurer la sécurité de notre communauté, nous vérifions la cohérence entre votre localisation déclarée et votre adresse IP. Les comptes présentant des incohérences importantes sont signalés pour vérification. Cette mesure aide à prévenir les faux profils et les utilisateurs malveillants."
        },
        {
          q: "Que faire si je rencontre un problème ou un profil suspect ?",
          a: "Votre sécurité est notre priorité. Si vous rencontrez un comportement inapproprié, un profil suspect ou tout problème technique, contactez-nous immédiatement à support@a-more-ai.com. Nous traitons toutes les signalisations rapidement et prenons les mesures appropriées, incluant la suspension ou suppression de comptes si nécessaire."
        },
        {
          q: "Comment supprimer mon compte ?",
          a: "Vous pouvez supprimer votre compte à tout moment depuis votre Dashboard, via le bouton 'Supprimer mon compte'. Cette action est irréversible et supprimera définitivement toutes vos données : profil, photos, matchs, messages et évaluations. Aucun remboursement n'est effectué en cas de suppression volontaire."
        },
        {
          q: "Quel âge minimum pour utiliser A-More AI ?",
          a: "Vous devez avoir au moins 18 ans révolus pour créer un compte sur A-More AI. Nous vérifions l'âge lors de l'inscription et tout utilisateur mineur sera immédiatement banni de la plateforme."
        }
      ]
    },
    // Terms
    terms: {
      title: 'Conditions Générales d\'Utilisation',
      lastUpdated: 'Dernière mise à jour : Janvier 2025',
      acceptAndContinue: 'Accepter et continuer',
      objectAndAcceptance: {
        title: '1. Objet et Acceptation',
        content: 'Les présentes conditions générales d\'utilisation régissent l\'utilisation de la plateforme A-more-AI, un service de rencontres en ligne utilisant l\'intelligence artificielle pour créer des connexions significatives entre célibataires.\n\nEn vous inscrivant sur A-more-AI, vous acceptez pleinement et sans réserve ces conditions générales. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser notre service.'
      },
      accessConditions: {
        title: '2. Conditions d\'Accès',
        ageMinimum: 'Âge minimum : Vous devez être âgé(e) de 18 ans révolus pour utiliser nos services.',
        legalCapacity: 'Vous devez avoir la capacité légale de conclure un contrat.',
        lawCompliance: 'Vous devez respecter toutes les lois applicables dans votre juridiction.',
        payment: 'Paiement :',
        free500: '• Les 500 premiers inscrits bénéficient d\'un accès gratuit',
        after500: '• Après ces 500 inscriptions, un paiement unique de 10 $ USD est requis pour accéder aux fonctionnalités complètes.',
        donations: '• Les dons volontaires sont encouragés en cas de rencontre réussie.',
        truthfulness: 'Véracité des informations : Vous vous engagez à fournir des informations exactes et à jour.'
      },
      dataProtection: {
        title: '3. Protection des Données',
        commitment: 'Nous nous engageons à protéger vos données personnelles conformément au RGPD. Vos informations sont utilisées uniquement pour améliorer nos services de matching par IA.',
        rights: 'Vous disposez d\'un droit d\'accès, de rectification et de suppression de vos données.',
        deletion: 'Vous pouvez désactiver ou supprimer votre compte à tout moment via les paramètres.'
      },
      serviceUsage: {
        title: '4. Utilisation du Service',
        intro: 'Vous vous engagez à utiliser le service de manière respectueuse envers les autres utilisateurs.',
        noHarassment: '• Ne pas harceler, menacer ou intimider',
        noOffensive: '• Les contenus offensants, haineux ou inappropriés sont interdits',
        noFalse: '• Ne pas fournir de fausses informations',
        noSpam: '• Ne pas envoyer de spam ou de contenu non sollicité',
        noIllegal: '• Ne pas utiliser le service à des fins illégales',
        noCommercial: '• Toute utilisation commerciale non autorisée est prohibée',
        exclusion: '• Le harcèlement et les comportements malveillants entraînent une exclusion'
      },
      userContent: {
        title: '5. Contenu Utilisateurs',
        ownership: 'Vous conservez la propriété de votre contenu, mais accordez à A-more-AI une licence pour l\'utiliser dans le cadre du service.'
      },
      artificialIntelligence: {
        title: '6. Intelligence Artificielle',
        usage: 'Notre service utilise Claude AI pour analyser les profils de personnalité et suggérer des matches compatibles. L\'IA traite vos réponses au questionnaire pour optimiser la qualité des rencontres.',
        disclaimer: 'Les suggestions de conversation et les scores de compatibilité sont générés automatiquement et ne constituent pas des garanties de succès relationnel.'
      },
      liabilityLimitation: {
        title: '7. Limitation de Responsabilité',
        asIs: 'A-more-AI est fourni « tel quel », c\'est une plateforme de mise en relation. Nous ne sommes pas responsables des interactions entre utilisateurs en dehors de la plateforme.',
        safety: 'Nous encourageons toujours la prudence lors de rencontres en personne et recommandons des lieux publics pour les premiers rendez-vous.'
      },
      termination: {
        title: '8. Résiliation',
        userRight: 'Vous pouvez résilier votre compte à tout moment via les paramètres sans aucun remboursement des frais d\'inscriptions.',
        serviceRight: 'En cas de violation de ces conditions, nous nous réservons le droit de suspendre ou supprimer votre compte sans aucun remboursement.'
      },
      modifications: {
        title: '9. Modifications',
        content: 'Nous pouvons modifier ces conditions à tout moment. Les modifications prendront effet dès leur publication.'
      },
      contact: {
        title: '10. Contact',
        content: 'Pour toute question concernant ces conditions générales, contactez-nous à : support@a-more-ai.com'
      }
    }
  },
  en: {
    landing: {
      title: 'A-More AI',
      subtitle: 'Artificial intelligence at the service of love',
      description: 'Find your soulmate with our advanced AI that analyzes your deep affinities',
      btnSignup: 'Start for free',
      btnLogin: 'Sign in',
      freeSignup: 'First 500 signups free!',
      whyTitle: 'Why A-More AI?',
      aiAdvanced: 'Advanced AI',
      aiAdvancedDesc: 'NLP analysis to understand your personality in depth',
      smartMatching: 'Smart Matching',
      smartMatchingDesc: 'Find people truly compatible with you',
      chatAssisted: 'Assisted Chat',
      chatAssistedDesc: 'AI helps you start captivating conversations',
      secure: 'Secure',
      secureDesc: 'Your data is protected and secure',
      readyTitle: 'Ready to find love?',
      readyDesc: 'Join thousands of singles who have already found their perfect match',
      btnCta: 'Create my account'
    },
    auth: {
      welcomeBack: 'Welcome back!',
      joinUs: 'Join A-More AI',
      loginDesc: 'Sign in to find love',
      signupDesc: 'Create your account for free',
      fullName: 'Full name',
      age: 'Age',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      location: 'Location',
      email: 'Email',
      password: 'Password',
      btnLogin: 'Sign in',
      btnSignup: 'Create my account',
      toggleSignup: "Don't have an account? Sign up",
      toggleLogin: 'Already have an account? Sign in',
      donationNote: 'If you meet someone successfully, we encourage you to make a donation to support the app.',
      ageError: 'You must be at least 18 years old to register',
      acceptTerms: 'I accept the',
      termsLink: 'terms and conditions',
      termsRequired: 'You must accept the terms and conditions'
    },
    questionnaire: {
      title: 'Tell us about yourself',
      subtitle: 'This will help us find your perfect match',
      step: 'Question',
      interestsTitle: 'What are your interests?',
      interestsDesc: 'Select at least 3 interests',
      personalityTitle: 'Your personality',
      bioTitle: 'Complete your profile',
      bio: 'Bio',
      bioPlaceholder: 'Tell us about yourself...',
      typePreference: 'Type of person you are looking for',
      typePlaceholder: 'E.g., Someone adventurous, caring...',
      btnNext: 'Next',
      btnBack: 'Back',
      btnFinish: 'Finish',
      introverted: 'Introverted',
      extroverted: 'Extroverted',
      routine: 'Routine',
      adventure: 'Adventure',
      rational: 'Rational',
      emotional: 'Emotional',
      improvise: 'Improvise',
      plan: 'Plan',
      alone: 'Alone',
      group: 'In group'
    },
    dashboard: {
      logout: 'Logout',
      myProfile: 'My Profile',
      discover: 'Discover',
      matches: 'My Matches',
      premium: 'Premium',
      interests: 'Interests',
      typeSearched: 'Type searched',
      notSpecified: 'Not specified',
      myPhotos: 'My Photos',
      noPhotos: 'No photos added',
      addPhotosDesc: 'Add photos to increase your match chances!',
      btnStartMatching: 'Start matching',
      noBio: 'No bio yet',
      noInterests: 'No interests added',
      addPhoto: 'Add'
    },
    discover: {
      title: 'Discover',
      score: 'Score',
      noMoreProfiles: 'No more profiles for now',
      noMoreDesc: 'Come back later to discover new profiles!',
      btnBackDashboard: 'Back to dashboard',
      loading: 'Searching for compatible profiles...'
    },
    matches: {
      title: 'My Matches',
      noMatches: 'No matches yet',
      noMatchesDesc: 'Start swiping to find matches!',
      btnDiscover: 'Discover profiles',
      btnChat: 'Chat'
    },
    chat: {
      startConversation: 'Start the conversation!',
      startDesc: 'Here are some suggestions to break the ice:',
      messagePlaceholder: 'Write your message...'
    },
    payment: {
      title: 'Premium Registration',
      subtitle: 'First 500 free signups reached',
      planTitle: 'A-More AI Registration',
      planDesc: 'Full platform access',
      oneTime: 'One-time payment',
      feature1: 'Unlimited AI matching',
      feature2: 'Chat with AI suggestions',
      feature3: 'Optimized profile',
      feature4: 'Priority support',
      btnPay: 'Pay with Stripe',
      btnBack: 'Back to home',
      checking: 'Checking payment...',
      wait: 'Please wait',
      success: 'Payment successful!',
      successDesc: 'You can now create your account',
      btnContinue: 'Continue registration',
      failed: 'Payment failed',
      failedDesc: 'Your payment was not successful',
      btnRetry: 'Retry'
    },
    common: {
      years: 'years old',
      loading: 'Loading...',
      saving: 'Saving...',
      sending: 'Sending...',
      back: 'Back'
    },
    // Menu / Footer
    menu: {
      tagline: "The dating app that uses AI to create authentic connections.",
      discover: 'Discover',
      howItWorks: 'How It Works',
      about: 'About',
      testimonials: 'Testimonials',
      faq: 'FAQ',
      blog: 'Blog',
      legal: 'Legal',
      terms: 'Terms of Use',
      privacy: 'Privacy Policy'
    },
    // Stats
    stats: {
      menRegistered: 'Men registered',
      womenRegistered: 'Women registered',
      successfulMatches: 'Successful matches',
      activeMembers: 'Active members'
    },
    // FAQ
    faq: {
      title: 'Frequently Asked Questions',
      back: 'Back',
      questions: [
        {
          q: "What is A-More AI?",
          a: "A-More AI is an innovative dating app that uses Claude artificial intelligence to analyze your deep affinities and connect you with truly compatible people. Our advanced technology goes beyond simple physical criteria to understand your personality, values, and aspirations."
        },
        {
          q: "How does AI matching work?",
          a: "Our system uses Claude AI, a cutting-edge artificial intelligence, to analyze your comprehensive personality questionnaire. The AI evaluates your character traits, interests, values, and relationship goals. It then compares this data with other users to identify the best compatibilities, calculating an affinity score based on multiple dimensions."
        },
        {
          q: "Is the app free?",
          a: "The first 500 registered users benefit from completely free access to all A-More AI features. After these 500 registrations, a one-time payment of $10 USD is required to access the platform. No recurring subscription, just a one-time payment for unlimited access."
        },
        {
          q: "Is my data protected?",
          a: "Absolutely. We take data protection very seriously. A-More AI is GDPR compliant and uses bank-level encryption to protect your personal information. You have the right to access, rectify, and delete your data at any time. You can delete your account and all your data via settings."
        },
        {
          q: "How does the personality questionnaire improve my matches?",
          a: "Our comprehensive questionnaire explores 8 compatibility dimensions: your values, communication style, life goals, hobbies, relationship vision, conflict management, emotional expression, and expectations. The more sincere and detailed your answers, the better the AI can identify truly compatible profiles for you."
        },
        {
          q: "What is the social rating system?",
          a: "The social rating system allows users to evaluate each other after matching on 5 criteria: Trust, Seriousness, Generosity, Behavior, and Communication. These ratings are anonymous and help the community identify quality profiles. You can rate a person only once per match, and your own detailed scores are visible in your Dashboard."
        },
        {
          q: "How does AI-assisted chat work?",
          a: "Once you have a mutual match, our AI suggests personalized conversation starters based on your common profiles and the reasons for your compatibility. These suggestions are designed to break the ice naturally and launch authentic and engaging conversations."
        },
        {
          q: "Can I use A-More AI in my language?",
          a: "Yes! A-More AI is available in 4 languages: French, English, Spanish, and German. You can change the language at any time via the language selector at the top right of the application."
        },
        {
          q: "How are locations verified?",
          a: "To ensure our community's safety, we verify consistency between your declared location and your IP address. Accounts with significant inconsistencies are flagged for verification. This measure helps prevent fake profiles and malicious users."
        },
        {
          q: "What should I do if I encounter a problem or suspicious profile?",
          a: "Your safety is our priority. If you encounter inappropriate behavior, a suspicious profile, or any technical issue, contact us immediately at support@a-more-ai.com. We handle all reports quickly and take appropriate measures, including account suspension or deletion if necessary."
        },
        {
          q: "How do I delete my account?",
          a: "You can delete your account at any time from your Dashboard, via the 'Delete my account' button. This action is irreversible and will permanently delete all your data: profile, photos, matches, messages, and ratings. No refund is provided in case of voluntary deletion."
        },
        {
          q: "What is the minimum age to use A-More AI?",
          a: "You must be at least 18 years old to create an account on A-More AI. We verify age during registration and any minor user will be immediately banned from the platform."
        }
      ]
    },
    interests: {
      music: 'Music',
      cinema: 'Cinema',
      travel: 'Travel',
      sport: 'Sport',
      reading: 'Reading',
      cooking: 'Cooking',
      art: 'Art',
      tech: 'Technology',
      nature: 'Nature',
      photo: 'Photography',
      dance: 'Dance',
      yoga: 'Yoga'
    }
  },
  es: {
    landing: {
      title: 'A-More AI',
      subtitle: 'Inteligencia artificial al servicio del amor',
      description: 'Encuentra tu alma gemela con nuestra IA avanzada que analiza tus afinidades profundas',
      btnSignup: 'Comenzar gratis',
      btnLogin: 'Iniciar sesión',
      freeSignup: '¡Primeros 500 registros gratis!',
      whyTitle: '¿Por qué A-More AI?',
      aiAdvanced: 'IA Avanzada',
      aiAdvancedDesc: 'Análisis NLP para entender tu personalidad en profundidad',
      smartMatching: 'Emparejamiento Inteligente',
      smartMatchingDesc: 'Encuentra personas verdaderamente compatibles contigo',
      chatAssisted: 'Chat Asistido',
      chatAssistedDesc: 'La IA te ayuda a iniciar conversaciones cautivadoras',
      secure: 'Seguro',
      secureDesc: 'Tus datos están protegidos y seguros',
      readyTitle: '¿Listo para encontrar el amor?',
      readyDesc: 'Únete a miles de solteros que ya han encontrado su pareja perfecta',
      btnCta: 'Crear mi cuenta'
    },
    auth: {
      welcomeBack: '¡Bienvenido de nuevo!',
      joinUs: 'Únete a A-More AI',
      loginDesc: 'Inicia sesión para encontrar el amor',
      signupDesc: 'Crea tu cuenta gratis',
      fullName: 'Nombre completo',
      age: 'Edad',
      gender: 'Género',
      male: 'Hombre',
      female: 'Mujer',
      location: 'Ubicación',
      email: 'Correo electrónico',
      password: 'Contraseña',
      btnLogin: 'Iniciar sesión',
      btnSignup: 'Crear mi cuenta',
      toggleSignup: '¿No tienes cuenta? Regístrate',
      toggleLogin: '¿Ya tienes cuenta? Inicia sesión',
      donationNote: 'Si conoces a alguien con éxito, te animamos a hacer una donación para apoyar la aplicación.',
      ageError: 'Debes tener al menos 18 años para registrarte'
    },
    questionnaire: {
      title: 'Cuéntanos sobre ti',
      subtitle: 'Esto nos ayudará a encontrar tu pareja perfecta',
      step: 'Pregunta',
      interestsTitle: '¿Cuáles son tus intereses?',
      interestsDesc: 'Selecciona al menos 3 intereses',
      personalityTitle: 'Tu personalidad',
      bioTitle: 'Completa tu perfil',
      bio: 'Biografía',
      bioPlaceholder: 'Cuéntanos sobre ti...',
      typePreference: 'Tipo de persona que buscas',
      typePlaceholder: 'Ej: Alguien aventurero, atento...',
      btnNext: 'Siguiente',
      btnBack: 'Atrás',
      btnFinish: 'Finalizar',
      introverted: 'Introvertido',
      extroverted: 'Extrovertido',
      routine: 'Rutina',
      adventure: 'Aventura',
      rational: 'Racional',
      emotional: 'Emocional',
      improvise: 'Improvisar',
      plan: 'Planificar',
      alone: 'Solo(a)',
      group: 'En grupo'
    },
    dashboard: {
      logout: 'Cerrar sesión',
      myProfile: 'Mi Perfil',
      discover: 'Descubrir',
      matches: 'Mis Coincidencias',
      premium: 'Premium',
      interests: 'Intereses',
      typeSearched: 'Tipo buscado',
      notSpecified: 'No especificado',
      myPhotos: 'Mis Fotos',
      noPhotos: 'No hay fotos añadidas',
      addPhotosDesc: '¡Añade fotos para aumentar tus posibilidades de match!',
      btnStartMatching: 'Comenzar emparejamiento',
      noBio: 'Sin biografía aún',
      noInterests: 'Sin intereses añadidos',
      addPhoto: 'Añadir'
    },
    discover: {
      title: 'Descubrir',
      score: 'Puntuación',
      noMoreProfiles: 'No hay más perfiles por ahora',
      noMoreDesc: '¡Vuelve más tarde para descubrir nuevos perfiles!',
      btnBackDashboard: 'Volver al panel',
      loading: 'Buscando perfiles compatibles...'
    },
    matches: {
      title: 'Mis Coincidencias',
      noMatches: 'No hay coincidencias aún',
      noMatchesDesc: '¡Comienza a deslizar para encontrar coincidencias!',
      btnDiscover: 'Descubrir perfiles',
      btnChat: 'Chatear'
    },
    chat: {
      startConversation: '¡Inicia la conversación!',
      startDesc: 'Aquí hay algunas sugerencias para romper el hielo:',
      messagePlaceholder: 'Escribe tu mensaje...'
    },
    payment: {
      title: 'Registro Premium',
      subtitle: 'Se alcanzaron los primeros 500 registros gratuitos',
      planTitle: 'Registro A-More AI',
      planDesc: 'Acceso completo a la plataforma',
      oneTime: 'Pago único',
      feature1: 'Emparejamiento IA ilimitado',
      feature2: 'Chat con sugerencias IA',
      feature3: 'Perfil optimizado',
      feature4: 'Soporte prioritario',
      btnPay: 'Pagar con Stripe',
      btnBack: 'Volver al inicio',
      checking: 'Verificando pago...',
      wait: 'Por favor espera',
      success: '¡Pago exitoso!',
      successDesc: 'Ahora puedes crear tu cuenta',
      btnContinue: 'Continuar registro',
      failed: 'Pago fallido',
      failedDesc: 'Tu pago no fue exitoso',
      btnRetry: 'Reintentar'
    },
    common: {
      years: 'años',
      loading: 'Cargando...',
      saving: 'Guardando...',
      sending: 'Enviando...',
      back: 'Atrás'
    },
    // Menu / Footer
    menu: {
      tagline: "La aplicación de citas que usa IA para crear conexiones auténticas.",
      discover: 'Descubrir',
      howItWorks: 'Cómo Funciona',
      about: 'Acerca de',
      testimonials: 'Testimonios',
      faq: 'FAQ',
      blog: 'Blog',
      legal: 'Legal',
      terms: 'Términos de Uso',
      privacy: 'Política de Privacidad'
    },
    // Stats
    stats: {
      menRegistered: 'Hombres registrados',
      womenRegistered: 'Mujeres registradas',
      successfulMatches: 'Matches exitosos',
      activeMembers: 'Miembros activos'
    },
    // FAQ
    faq: {
      title: 'Preguntas Frecuentes',
      back: 'Atrás',
      questions: [
        {
          q: "¿Qué es A-More AI?",
          a: "A-More AI es una aplicación de citas innovadora que utiliza inteligencia artificial Claude para analizar tus afinidades profundas y conectarte con personas verdaderamente compatibles. Nuestra tecnología avanzada va más allá de simples criterios físicos para comprender tu personalidad, valores y aspiraciones."
        },
        {
          q: "¿Cómo funciona el matching por IA?",
          a: "Nuestro sistema utiliza Claude AI, una inteligencia artificial de vanguardia, para analizar tu cuestionario de personalidad exhaustivo. La IA evalúa tus rasgos de carácter, intereses, valores y objetivos relacionales. Luego compara estos datos con otros usuarios para identificar las mejores compatibilidades, calculando una puntuación de afinidad basada en múltiples dimensiones."
        },
        {
          q: "¿La aplicación es gratuita?",
          a: "Los primeros 500 usuarios registrados se benefician de acceso completamente gratuito a todas las funcionalidades de A-More AI. Después de estos 500 registros, se requiere un pago único de $10 USD para acceder a la plataforma. Sin suscripción recurrente, solo un pago único para acceso ilimitado."
        },
        {
          q: "¿Están protegidos mis datos?",
          a: "Absolutamente. Tomamos muy en serio la protección de datos. A-More AI cumple con GDPR y utiliza cifrado de nivel bancario para proteger tu información personal. Tienes derecho a acceder, rectificar y eliminar tus datos en cualquier momento. Puedes eliminar tu cuenta y todos tus datos a través de la configuración."
        },
        {
          q: "¿Cómo mejora el cuestionario de personalidad mis matches?",
          a: "Nuestro cuestionario exhaustivo explora 8 dimensiones de compatibilidad: tus valores, estilo de comunicación, objetivos de vida, pasatiempos, visión de la relación, gestión de conflictos, expresión emocional y expectativas. Cuanto más sinceras y detalladas sean tus respuestas, mejor podrá la IA identificar perfiles verdaderamente compatibles para ti."
        },
        {
          q: "¿Qué es el sistema de calificación social?",
          a: "El sistema de calificación social permite a los usuarios evaluarse mutuamente después de hacer match en 5 criterios: Confianza, Seriedad, Generosidad, Comportamiento y Comunicación. Estas calificaciones son anónimas y ayudan a la comunidad a identificar perfiles de calidad. Puedes calificar a una persona solo una vez por match, y tus propias puntuaciones detalladas son visibles en tu Dashboard."
        },
        {
          q: "¿Cómo funciona el chat asistido por IA?",
          a: "Una vez que tienes un match mutuo, nuestra IA sugiere iniciadores de conversación personalizados basados en vos perfiles comunes y las razones de vuestra compatibilidad. Estas sugerencias están diseñadas para romper el hielo naturalmente y lanzar conversaciones auténticas y atractivas."
        },
        {
          q: "¿Puedo usar A-More AI en mi idioma?",
          a: "¡Sí! A-More AI está disponible en 4 idiomas: Francés, Inglés, Español y Alemán. Puedes cambiar el idioma en cualquier momento a través del selector de idioma en la parte superior derecha de la aplicación."
        },
        {
          q: "¿Cómo se verifican las ubicaciones?",
          a: "Para garantizar la seguridad de nuestra comunidad, verificamos la coherencia entre tu ubicación declarada y tu dirección IP. Las cuentas con inconsistencias significativas se marcan para verificación. Esta medida ayuda a prevenir perfiles falsos y usuarios malintencionados."
        },
        {
          q: "¿Qué debo hacer si encuentro un problema o un perfil sospechoso?",
          a: "Tu seguridad es nuestra prioridad. Si encuentras comportamiento inapropiado, un perfil sospechoso o cualquier problema técnico, contáctanos inmediatamente en support@a-more-ai.com. Manejamos todos los informes rápidamente y tomamos medidas apropiadas, incluyendo suspensión o eliminación de cuentas si es necesario."
        },
        {
          q: "¿Cómo elimino mi cuenta?",
          a: "Puedes eliminar tu cuenta en cualquier momento desde tu Dashboard, a través del botón 'Eliminar mi cuenta'. Esta acción es irreversible y eliminará permanentemente todos tus datos: perfil, fotos, matches, mensajes y calificaciones. No se proporciona reembolso en caso de eliminación voluntaria."
        },
        {
          q: "¿Cuál es la edad mínima para usar A-More AI?",
          a: "Debes tener al menos 18 años para crear una cuenta en A-More AI. Verificamos la edad durante el registro y cualquier usuario menor será inmediatamente prohibido de la plataforma."
        }
      ]
    },
    interests: {
      music: 'Música',
      cinema: 'Cine',
      travel: 'Viajes',
      sport: 'Deporte',
      reading: 'Lectura',
      cooking: 'Cocina',
      art: 'Arte',
      tech: 'Tecnología',
      nature: 'Naturaleza',
      photo: 'Fotografía',
      dance: 'Danza',
      yoga: 'Yoga'
    }
  },
  de: {
    landing: {
      title: 'A-More AI',
      subtitle: 'Künstliche Intelligenz im Dienste der Liebe',
      description: 'Finden Sie Ihren Seelenverwandten mit unserer fortschrittlichen KI, die Ihre tiefen Affinitäten analysiert',
      btnSignup: 'Kostenlos starten',
      btnLogin: 'Anmelden',
      freeSignup: 'Die ersten 500 Anmeldungen kostenlos!',
      whyTitle: 'Warum A-More AI?',
      aiAdvanced: 'Fortgeschrittene KI',
      aiAdvancedDesc: 'NLP-Analyse zum tieferen Verständnis Ihrer Persönlichkeit',
      smartMatching: 'Intelligentes Matching',
      smartMatchingDesc: 'Finden Sie Menschen, die wirklich zu Ihnen passen',
      chatAssisted: 'Unterstützter Chat',
      chatAssistedDesc: 'Die KI hilft Ihnen, fesselnde Gespräche zu beginnen',
      secure: 'Sicher',
      secureDesc: 'Ihre Daten sind geschützt und sicher',
      readyTitle: 'Bereit, die Liebe zu finden?',
      readyDesc: 'Treten Sie Tausenden von Singles bei, die bereits ihren perfekten Partner gefunden haben',
      btnCta: 'Mein Konto erstellen'
    },
    auth: {
      welcomeBack: 'Willkommen zurück!',
      joinUs: 'Treten Sie A-More AI bei',
      loginDesc: 'Melden Sie sich an, um die Liebe zu finden',
      signupDesc: 'Erstellen Sie Ihr Konto kostenlos',
      fullName: 'Vollständiger Name',
      age: 'Alter',
      gender: 'Geschlecht',
      male: 'Mann',
      female: 'Frau',
      location: 'Standort',
      email: 'E-Mail',
      password: 'Passwort',
      btnLogin: 'Anmelden',
      btnSignup: 'Mein Konto erstellen',
      toggleSignup: 'Noch kein Konto? Registrieren Sie sich',
      toggleLogin: 'Bereits ein Konto? Anmelden',
      donationNote: 'Wenn Sie erfolgreich jemanden treffen, ermutigen wir Sie, eine Spende zur Unterstützung der App zu leisten.',
      ageError: 'Sie müssen mindestens 18 Jahre alt sein, um sich zu registrieren'
    },
    questionnaire: {
      title: 'Erzählen Sie uns von sich',
      subtitle: 'Dies wird uns helfen, Ihren perfekten Partner zu finden',
      step: 'Frage',
      interestsTitle: 'Was sind Ihre Interessen?',
      interestsDesc: 'Wählen Sie mindestens 3 Interessen',
      personalityTitle: 'Ihre Persönlichkeit',
      bioTitle: 'Vervollständigen Sie Ihr Profil',
      bio: 'Biografie',
      bioPlaceholder: 'Erzählen Sie uns von sich...',
      typePreference: 'Gesuchter Personentyp',
      typePlaceholder: 'Z.B., Jemand abenteuerlustig, fürsorglich...',
      btnNext: 'Weiter',
      btnBack: 'Zurück',
      btnFinish: 'Fertig',
      introverted: 'Introvertiert',
      extroverted: 'Extrovertiert',
      routine: 'Routine',
      adventure: 'Abenteuer',
      rational: 'Rational',
      emotional: 'Emotional',
      improvise: 'Improvisieren',
      plan: 'Planen',
      alone: 'Allein',
      group: 'In Gruppe'
    },
    dashboard: {
      logout: 'Abmelden',
      myProfile: 'Mein Profil',
      discover: 'Entdecken',
      matches: 'Meine Matches',
      premium: 'Premium',
      interests: 'Interessen',
      typeSearched: 'Gesuchter Typ',
      notSpecified: 'Nicht angegeben',
      myPhotos: 'Meine Fotos',
      noPhotos: 'Keine Fotos hinzugefügt',
      addPhotosDesc: 'Fügen Sie Fotos hinzu, um Ihre Match-Chancen zu erhöhen!',
      btnStartMatching: 'Matching starten',
      noBio: 'Noch keine Biografie',
      noInterests: 'Keine Interessen hinzugefügt',
      addPhoto: 'Hinzufügen'
    },
    discover: {
      title: 'Entdecken',
      score: 'Bewertung',
      noMoreProfiles: 'Keine weiteren Profile im Moment',
      noMoreDesc: 'Kommen Sie später zurück, um neue Profile zu entdecken!',
      btnBackDashboard: 'Zurück zum Dashboard',
      loading: 'Suche nach kompatiblen Profilen...'
    },
    matches: {
      title: 'Meine Matches',
      noMatches: 'Noch keine Matches',
      noMatchesDesc: 'Beginnen Sie zu swipen, um Matches zu finden!',
      btnDiscover: 'Profile entdecken',
      btnChat: 'Chatten'
    },
    chat: {
      startConversation: 'Beginnen Sie das Gespräch!',
      startDesc: 'Hier sind einige Vorschläge, um das Eis zu brechen:',
      messagePlaceholder: 'Schreiben Sie Ihre Nachricht...'
    },
    payment: {
      title: 'Premium-Registrierung',
      subtitle: 'Die ersten 500 kostenlosen Anmeldungen sind erreicht',
      planTitle: 'A-More AI Registrierung',
      planDesc: 'Voller Plattformzugang',
      oneTime: 'Einmalige Zahlung',
      feature1: 'Unbegrenztes KI-Matching',
      feature2: 'Chat mit KI-Vorschlägen',
      feature3: 'Optimiertes Profil',
      feature4: 'Prioritäts-Support',
      btnPay: 'Mit Stripe bezahlen',
      btnBack: 'Zurück zur Startseite',
      checking: 'Zahlung wird überprüft...',
      wait: 'Bitte warten',
      success: 'Zahlung erfolgreich!',
      successDesc: 'Sie können jetzt Ihr Konto erstellen',
      btnContinue: 'Registrierung fortsetzen',
      failed: 'Zahlung fehlgeschlagen',
      failedDesc: 'Ihre Zahlung war nicht erfolgreich',
      btnRetry: 'Erneut versuchen'
    },
    common: {
      years: 'Jahre alt',
      loading: 'Laden...',
      saving: 'Speichern...',
      sending: 'Senden...',
      back: 'Zurück'
    },
    // Menu / Footer
    menu: {
      tagline: "Die Dating-App, die KI nutzt, um authentische Verbindungen zu schaffen.",
      discover: 'Entdecken',
      howItWorks: 'Wie es Funktioniert',
      about: 'Über Uns',
      testimonials: 'Erfahrungsberichte',
      faq: 'FAQ',
      blog: 'Blog',
      legal: 'Rechtliches',
      terms: 'Nutzungsbedingungen',
      privacy: 'Datenschutzrichtlinie'
    },
    // Stats
    stats: {
      menRegistered: 'Männer registriert',
      womenRegistered: 'Frauen registriert',
      successfulMatches: 'Erfolgreiche Matches',
      activeMembers: 'Aktive Mitglieder'
    },
    // FAQ
    faq: {
      title: 'Häufig Gestellte Fragen',
      back: 'Zurück',
      questions: [
        {
          q: "Was ist A-More AI?",
          a: "A-More AI ist eine innovative Dating-App, die Claude-Künstliche Intelligenz verwendet, um Ihre tiefen Affinitäten zu analysieren und Sie mit wirklich kompatiblen Menschen zu verbinden. Unsere fortschrittliche Technologie geht über einfache physische Kriterien hinaus, um Ihre Persönlichkeit, Werte und Ambitionen zu verstehen."
        },
        {
          q: "Wie funktioniert das KI-Matching?",
          a: "Unser System verwendet Claude AI, eine hochmoderne künstliche Intelligenz, um Ihren umfassenden Persönlichkeitsfragebogen zu analysieren. Die KI bewertet Ihre Charaktereigenschaften, Interessen, Werte und Beziehungsziele. Sie vergleicht dann diese Daten mit anderen Benutzern, um die besten Kompatibilitäten zu identifizieren und berechnet einen Affinitätsscore basierend auf mehreren Dimensionen."
        },
        {
          q: "Ist die App kostenlos?",
          a: "Die ersten 500 registrierten Benutzer profitieren von völlig kostenlosem Zugang zu allen A-More AI-Funktionen. Nach diesen 500 Registrierungen ist eine einmalige Zahlung von $10 USD erforderlich, um auf die Plattform zuzugreifen. Kein wiederkehrendes Abonnement, nur eine einmalige Zahlung für unbegrenzten Zugang."
        },
        {
          q: "Sind meine Daten geschützt?",
          a: "Absolut. Wir nehmen Datenschutz sehr ernst. A-More AI ist DSGVO-konform und verwendet Verschlüsselung auf Bankniveau, um Ihre persönlichen Informationen zu schützen. Sie haben jederzeit das Recht auf Zugriff, Berichtigung und Löschung Ihrer Daten. Sie können Ihr Konto und alle Ihre Daten über die Einstellungen löschen."
        },
        {
          q: "Wie verbessert der Persönlichkeitsfragebogen meine Matches?",
          a: "Unser umfassender Fragebogen untersucht 8 Kompatibilitätsdimensionen: Ihre Werte, Kommunikationsstil, Lebensziele, Hobbys, Beziehungsvision, Konfliktmanagement, emotionaler Ausdruck und Erwartungen. Je aufrichtiger und detaillierter Ihre Antworten sind, desto besser kann die KI wirklich kompatible Profile für Sie identifizieren."
        },
        {
          q: "Was ist das soziale Bewertungssystem?",
          a: "Das soziale Bewertungssystem ermöglicht es Benutzern, sich gegenseitig nach dem Matching anhand von 5 Kriterien zu bewerten: Vertrauen, Ernsthaftigkeit, Großzügigkeit, Verhalten und Kommunikation. Diese Bewertungen sind anonym und helfen der Community, Qualitätsprofile zu identifizieren. Sie können eine Person nur einmal pro Match bewerten, und Ihre eigenen detaillierten Scores sind in Ihrem Dashboard sichtbar."
        },
        {
          q: "Wie funktioniert der KI-unterstützte Chat?",
          a: "Sobald Sie ein gegenseitiges Match haben, schlägt unsere KI personalisierte Gesprächsstarter vor, die auf Ihren gemeinsamen Profilen und den Gründen für Ihre Kompatibilität basieren. Diese Vorschläge sind darauf ausgelegt, das Eis natürlich zu brechen und authentische und ansprechende Gespräche zu starten."
        },
        {
          q: "Kann ich A-More AI in meiner Sprache verwenden?",
          a: "Ja! A-More AI ist in 4 Sprachen verfügbar: Französisch, Englisch, Spanisch und Deutsch. Sie können die Sprache jederzeit über den Sprachselektor oben rechts in der Anwendung ändern."
        },
        {
          q: "Wie werden Standorte überprüft?",
          a: "Um die Sicherheit unserer Community zu gewährleisten, überprüfen wir die Konsistenz zwischen Ihrem angegebenen Standort und Ihrer IP-Adresse. Konten mit erheblichen Inkonsistenzen werden zur Überprüfung markiert. Diese Maßnahme hilft, gefälschte Profile und böswillige Benutzer zu verhindern."
        },
        {
          q: "Was soll ich tun, wenn ich ein Problem oder ein verdächtiges Profil antreffe?",
          a: "Ihre Sicherheit ist unsere Priorität. Wenn Sie unangemessenes Verhalten, ein verdächtiges Profil oder ein technisches Problem feststellen, kontaktieren Sie uns sofort unter support@a-more-ai.com. Wir bearbeiten alle Meldungen schnell und ergreifen geeignete Maßnahmen, einschließlich Kontosperrung oder -löschung, falls erforderlich."
        },
        {
          q: "Wie lösche ich mein Konto?",
          a: "Sie können Ihr Konto jederzeit über Ihr Dashboard löschen, über die Schaltfläche 'Mein Konto löschen'. Diese Aktion ist irreversibel und wird alle Ihre Daten dauerhaft löschen: Profil, Fotos, Matches, Nachrichten und Bewertungen. Es erfolgt keine Rückerstattung bei freiwilliger Löschung."
        },
        {
          q: "Welches Mindestalter gilt für die Nutzung von A-More AI?",
          a: "Sie müssen mindestens 18 Jahre alt sein, um ein Konto bei A-More AI zu erstellen. Wir überprüfen das Alter bei der Registrierung, und jeder minderjährige Benutzer wird sofort von der Plattform ausgeschlossen."
        }
      ]
    },
    interests: {
      music: 'Musik',
      cinema: 'Kino',
      travel: 'Reisen',
      sport: 'Sport',
      reading: 'Lesen',
      cooking: 'Kochen',
      art: 'Kunst',
      tech: 'Technologie',
      nature: 'Natur',
      photo: 'Fotografie',
      dance: 'Tanzen',
      yoga: 'Yoga'
    }
  }
};
// Temporary marker - will be integrated properly
